import {ModelLoader} from "./loader";
import * as THREE from "three";

export class ImageModelLoader extends ModelLoader {

    constructor() {
        super();
        this.loader = new THREE.TextureLoader();
    }

    onLoad(tex, callback) {
        const planeGeom = new THREE.PlaneGeometry(20, 20); //TODO Check size

        //TODO Do we want lambert?
        const material = new THREE.MeshStandardMaterial({
            side: THREE.DoubleSide,
            color: 0xffffff,
            map: tex
        });

        tex.needsUpdate = true;
        const mesh = new THREE.Mesh(planeGeom, material);

        mesh.scale.set(1.0, tex.image.height / tex.image.width, 1.0);

        super.onLoad(mesh, callback); //Call the callback with our model
    }
}